module.exports = __webpack_public_path__ + "img/LMS.1b6b066c.jpg";